"use client";

import { useState } from "react";
import {
	Dialog,
	DialogContent,
	DialogHeader,
	DialogTitle,
	DialogFooter,
} from "@/components/ui/dialog";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";
import { withFrontendOrigin } from "@/lib/apiHeaders";
import { authFetch, parseAuthJson } from "@/lib/authClient";

export default function ForgotPasswordButton() {
	const [open, setOpen] = useState(false);
	const [email, setEmail] = useState("");
	const [loading, setLoading] = useState(false);

	const handlePasswordResetRequest = async () => {
		if (!email) {
			toast.error("Inserisci un'email");
			return;
		}
		setLoading(true);
		try {
			const res = await authFetch("/auth/request-reset", {
				method: "POST",
				headers: withFrontendOrigin({ "Content-Type": "application/json" }),
				body: JSON.stringify({ email: email.trim().toLowerCase() }),
			});

			const data = await parseAuthJson<{ error?: string; showToast?: boolean }>(res);
			if (res.ok && data?.showToast) {
				toast.success("Controlla la tua email per il link di reset");
				setOpen(false);
				setEmail("");
			} else {
				toast.error(data?.error || "Errore durante il reset");
			}
		} catch (err) {
			toast.error("Errore di connessione");
		} finally {
			setLoading(false);
		}
	};

	return (
		<>
			<button
				type="button"
				onClick={() => setOpen(true)}
				className="cursor-pointer text-sm text-(--card-foreground) hover:underline mb-1"
			>
				Password dimenticata?
			</button>

			<Dialog open={open} onOpenChange={setOpen}>
				<DialogContent className="sm:max-w-md">
					<DialogHeader>
						<DialogTitle className="text-(--card-foreground)">
							Recupera password
						</DialogTitle>
					</DialogHeader>
					<div className="">
						<Input
							type="email"
							placeholder="Inserisci la tua email"
							value={email}
							onChange={(e) => setEmail(e.target.value)}
						/>
					</div>
					<DialogFooter className="">
						<Button
							onClick={() => setOpen(false)}
              className="cursor-pointer"
              variant="secondary"
              type="button"
						>
							Annulla
						</Button>
						<Button
							onClick={handlePasswordResetRequest}
							disabled={loading}
              className="bg-(--btn-bg) text-(--btn-foreground) cursor-pointer rounded-lg px-6 py-2 text-md font-semibold transition-all duration-300 hover:bg-(--btn-hover)"
						>
							{loading ? "Invio..." : "Invia link"}
						</Button>
					</DialogFooter>
				</DialogContent>
			</Dialog>
		</>
	);
}
